import { render, staticRenderFns } from "./ApprovalPage.vue?vue&type=template&id=df6b1530&scoped=true"
import script from "./ApprovalPage.vue?vue&type=script&lang=js"
export * from "./ApprovalPage.vue?vue&type=script&lang=js"
import style0 from "./ApprovalPage.vue?vue&type=style&index=0&id=df6b1530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6b1530",
  null
  
)

export default component.exports